<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/WOCnH0/tc-custom/9781466804876.jpg?1737750225709" alt="This image is the cover for the book Postsingular"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Postsingular
      </h1>
      <p class="bookDescription body article font2">
        <p>It all begins next year in California. A maladjusted computer industry billionaire and a somewhat crazy US President initiate a radical transformation of the world through sentient nanotechnology; sort of the equivalent of biological artificial intelligence. At first they succeed, but their plans are reversed by Chu, an autistic boy. The next time it isn't so easy to stop them. <br/><br/>Most of the story takes place in a world after a heretofore unimaginable transformation, where all the things look the same but all the people are different (they're able to read each others' minds, for starters). Travel to and from other nearby worlds in the quantum universe is possible, so now our world is visited by giant humanoids from another quantum universe, and some of them mean to tidy up the mess we've made. Or maybe just run things.<br/><br/><br/>At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rudy Rucker
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b3efc646